export class ExpirationConfigurationDto {
    public id?: number;

    public startCampaignSequence: number;

    public campaignsToExpire: number;
}
